import { Award, Sparkles, Crown, Truck } from "lucide-react";

const PILLARS = [
  { icon: Award, title: "Three decades", text: "Of weaving stories with families across generations." },
  { icon: Sparkles, title: "Authentic weaves", text: "Direct from master weavers in Banaras, Kanchipuram & beyond." },
  { icon: Crown, title: "Bridal styling", text: "Personal consultations to find the saree that's truly you." },
  { icon: Truck, title: "Pan-India shipping", text: "Insured, tracked & wrapped with the care of a personal gift." },
];

export const Story = () => {
  return (
    <section id="story" className="relative py-24 md:py-36 bg-cream overflow-hidden">
      <div
        className="absolute -right-32 top-10 w-[480px] h-[480px] opacity-[0.07] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/8465992/pexels-photo-8465992.jpeg')",
          backgroundSize: "cover",
          filter: "blur(2px)",
        }}
        aria-hidden
      />

      <div className="container-narrow relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] overflow-hidden">
            <img
              src="/media/bride.jpg"
              alt="A bride in heritage red & gold drape"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-6 md:-right-10 bg-cream border border-line p-6 md:p-7 max-w-[260px] shadow-[0_30px_60px_-30px_rgba(82,58,135,0.35)]">
            <p className="font-serif text-3xl md:text-4xl text-garnet leading-none">30+</p>
            <p className="overline mt-3">Years curating heritage drapes</p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="overline">Our Story</span>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl text-ink leading-[1.05]">
            A family boutique built on
            <span className="italic text-garnet"> trust</span>, threads & timeless taste.
          </h2>
          <div className="gold-divider my-8" />
          <p className="text-muteink leading-relaxed text-base md:text-lg max-w-2xl">
            New Varsha Sarees began as a small family-run boutique with one
            simple promise — every saree we sell, we'd be proud to drape on our
            own daughters. Three decades on, that promise still guides every
            stitch we recommend, every weaver we partner with, and every bride
            who walks through our doors.
          </p>
          <p className="mt-5 text-muteink leading-relaxed text-base md:text-lg max-w-2xl">
            From hand-loomed Banarasi tissue to heirloom Kanjeevaram, our edit
            is small, considered and deeply personal. Welcome — take a seat,
            we'll bring out the chai.
          </p>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {PILLARS.map(({ icon: Icon, title, text }) => (
              <div
                key={title}
                data-testid={`pillar-${title.toLowerCase().replace(/\s/g, "-")}`}
                className="border-t border-line pt-5"
              >
                <Icon className="text-gold" size={22} strokeWidth={1.4} />
                <h4 className="mt-3 font-serif text-2xl text-ink">{title}</h4>
                <p className="mt-1 text-muteink text-sm leading-relaxed">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
